import { createSelector } from '@ngrx/store';

import { Coverage } from '@models/swagger';
import { State } from './reducer';
import { selectPutCoveragesState } from '../selectors';

export const getData = createSelector(selectPutCoveragesState, (state: State) => state.data);

export const getError = createSelector(selectPutCoveragesState, (state: State) => state.error);

export const getLoading = createSelector(selectPutCoveragesState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: Coverage[]) => T) =>
  createSelector(selectPutCoveragesState, (state: State) => fn(state.data));
